import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const FieldText = ({ label, value, onChange, placeholder, invalid, code, type = "text", required, children, subLabel }) => {

    //const isInvalid = required && invalid;
    const isInvalid = Boolean(invalid);

    return (
        <div className = 'field-text'>
            { label && <label className = 'form__label field-text__label'>{label}
                {required &&
                <span className = 'form__label-require'>*</span>
                }
            </label> }
            {subLabel &&
            <div className = 'form__sub-label'>
                <span>{subLabel}</span>
            </div>
            }
            <input
                className = { `field-text__field ${isInvalid ? "field-text__field--invalid" : ""}` } name = { code }
                placeholder = { placeholder }
                type = { type }
                value = { value }
                onChange = { onChange }
            />
            {children}
            {isInvalid && <span className = 'form__error'>{invalid}</span>}
        </div>
    );
};

FieldText.propTypes = {
    placeholder: PropTypes.string.isRequired,
    code:        PropTypes.string.isRequired,
    onChange:    PropTypes.func.isRequired,
    label:       PropTypes.string,
    subLabel:    PropTypes.string,
    invalid:     PropTypes.string,
    type:        PropTypes.string,
    value:       PropTypes.string,
    required:    PropTypes.bool,
};

export default FieldText;
